import * as types from '@/store/mutations'
import api from '@/services/campaigns.js'

const getters = {
    campaigns: (state)=> state.campaigns,
    getCampaigns: (state) => () => {
        return state.campaigns
    }
}

const actions = {
  loadActiveDemoCampaigns({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAllCampaigns().then((res)=>{
        commit(types.SET_ALL_CAMPAIGNS,res)
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  },
  storeCampaignBasket(context, payload  ) {
    return new Promise((resolve, reject) => {
      api.setCampaignBasket(payload).then((res)=>{
        resolve(res)
      }).catch((ex)=>{
        reject(ex)
      })
    })
  }

}

const mutations = {
    [types.SET_ALL_CAMPAIGNS](state, campaigns) {
        state.campaigns = campaigns
    }
}

const state = {
  campaigns: []
}

export default {
  state,
  getters,
  actions,
  mutations
}
